module.exports = __webpack_public_path__ + "static/img/user-4.2fe3d724.jpg";